<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Stok Inseminasi">
		  <z-table title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.role('Pentadbir Sistem')">
              <w-button dark class="green--bg ml1"  @click="add()">
                  <w-icon class="mr1">fal fa-plus</w-icon> Tambah Al Man
              </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            Tindakan
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
            <inertia-link :href="$route('baka.show',item.baka_id)" class="w-button black  info-dark1--bg size--md be fs-2"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
            </inertia-link>
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        Tambah Al Man
      </template>
      <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
        <z-select class="mt4" :items="user" label="Al Man *"  v-model="form.user_id"  :validators="[validators.required]"/>
        <z-select class="mt4" :items="lkp_ternakan" label="Ternakan *"  v-model="form.lkp_ternakan_id" @input="getBaka(form.lkp_ternakan_id)" :validators="[validators.required]"/>
        <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form.lkp_baka_id" @input="cekBaka(form.lkp_baka_id)"  :validators="[validators.required]"/>
        <w-input class="mt4" label="Tersesia" type="number" v-model="form.sedia"  disabled/>
         <w-input class="mt4" label="Jumlah" type="number" v-model="form.jumlah"  :validators="[validators.required]"/>

      </w-form>
      <template #actions>
        <div class="spacer" />
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
        <template v-if="form.jumlah > 0 && form.jumlah <= form.sedia && form.user_id > 0 && form.lkp_ternakan_id > 0 && form.lkp_baka_id > 0">
          <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()" >Simpan</w-button>
        </template>
        <template v-else>
          <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()" disabled>Simpan</w-button>
        </template>
        
      </template>
    </w-dialog>
  </zen-one>
  
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'insemination.stok',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Inseminasi Stok', route: '/insemination/stok' },
      ],
      form :{
        user_id : '',
        lkp_ternakan_id : '',
        lkp_baka_id : '',
        sedia : 0,
        jumlah : 0
      },
      user : [],
      lkp_ternakan : [],
      lkp_baka : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      
    }
  },
  methods: {
    getUser(){
      this.$zcomm.get(this.api_service + 'lookup/alman', {}).then(res => {
        this.user = res
      })
    },

    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },
    add(){
      this.form = {
        user_id : '',
        lkp_ternakan_id : '',
        lkp_baka_id : '',
        sedia : 0,
        total : 0
      }
      this.dialog.show = true
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
      })
    },

    cekBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/cek_baka/'+i, {}).then(res => {
        this.form.sedia = res
      })
    },

    submit(){
      this.$zcomm.post(this.resourceurl+'.store' , this.form)
        .then(res => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
          }
          this.dialog.show = false
          this.$inertia.visit(this.$page.url)

        })
    }
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.getUser()
    this.getTernakan()
    this.dialog.width = 500
      
  },
}
</script>
